import { render, staticRenderFns } from "./ApproveLabourerSchedulePage.vue?vue&type=template&id=64a382ea&scoped=true&"
import script from "./ApproveLabourerSchedulePage.vue?vue&type=script&lang=js&"
export * from "./ApproveLabourerSchedulePage.vue?vue&type=script&lang=js&"
import style0 from "./ApproveLabourerSchedulePage.vue?vue&type=style&index=0&id=64a382ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a382ea",
  null
  
)

export default component.exports